module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tips"
  }, [(_vm.info.reverse ? _vm.info.value <= 0 : _vm.info.value >= 0) ? _c('img', {
    attrs: {
      "src": require("static/img/happy.png"),
      "alt": "图"
    }
  }) : _c('img', {
    attrs: {
      "src": require("static/img/sad.png"),
      "alt": "图"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [(_vm.info.title) ? _c('h2', [_vm._v("\n\t            " + _vm._s(_vm.info.title) + "\n\t            "), _c('em', {
    class: {
      'red': _vm.info.value < 0
    }
  }, [_vm._v("\n\t                " + _vm._s(_vm._f("formatNum")(_vm.info.value)) + "\n\t            ")])]) : _vm._e(), _vm._v(" "), _c('p', {
    class: {
      'other': !_vm.info.title
    },
    domProps: {
      "innerHTML": _vm._s(_vm.info.suggest)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1278c5a1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/tips/Tips.vue
// module id = 640
// module chunks = 0